<template src="./template.html"></template>

<script>
export default {
  name: 'radio',
  props: {
    name: {
      type: String,
    },
    label: {
      default: true,
    },
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    radioButtonValue: {
      get: function () {
        return this.value
      },
      set: function () {
        if (this.disabled) return

        this.$emit('input', this.label)
        this.$emit('change', this.label)
      },
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Radio/index.vue